import axios from "axios";
import FileDownload from "js-file-download";

export const downloadEmployeeFile = async ({
  pdsType,
  employeeId,
  employeeName,
  token,
}: {
  pdsType: "long" | "short";
  employeeId: string | number | undefined;
  employeeName: string;
  token: string;
}) => {
  try {
    const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_REPORT_GENERATION_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_REPORT_GENERATION_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_REPORT_GENERATION_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/reports/pdf/${pdsType}-pds/employee-info/${employeeId}`;

    const response = await axios({
      url: apiEndPoint,
      method: "GET",
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    FileDownload(response.data, `${employeeName} (${pdsType}).pdf`);
  } catch (error) {
    alert("Error downloading employee file");
  }
};
